import Decimal from 'decimal.js';

/**
 * @param {number|string} value
 * @param {{ precision?: number }} [options] - Room for future options (e.g. rounding mode) without breaking callers.
 * @returns {number}
 */
function round(value, { precision = 0 } = {}) {
  return new Decimal(value).toDecimalPlaces(precision).toNumber();
}

/**
 * Rounds a number to a fixed number of decimal places (e.g. currency precision).
 * Uses decimal.js so rounding is not skewed by binary floating-point representation.
 *
 * @param {number|null|undefined} number - Value to round. `null` → `0`, `undefined` → `NaN`.
 * @param {number} [decimals=2] - Decimal places.
 * @returns {number}
 */
export default function roundPrice(number, decimals = 2) {
  if (number === null) return 0;
  if (number === undefined) return NaN;
  const n = Number(number);
  if (Number.isNaN(n)) return NaN;
  return round(n, { precision: decimals });
}
